import { Card, CardButtonActionMode, HeaderGradient, MiniCard, Row } from '@app/components';
import React, { memo } from 'react';
import { theme } from '@app/theme';
import { useDynamicSizes } from '@app/hooks';
import LinearGradient from 'react-native-linear-gradient';
import { StyleSheet } from 'react-native';
import { IOrderCancelReason } from '@app/common';
import { UseFormReturn, useWatch } from 'react-hook-form';

type OrderCancelReasonCardProps = {
  orderCancelReason?: Partial<IOrderCancelReason>
  formMethods: UseFormReturn<any, any, any>;
  toggle: (mode: CardButtonActionMode) => void;
};

const formatCardData = (partialOrderCancelReason: Partial<IOrderCancelReason>) => {
  return {
    name: partialOrderCancelReason?.reason || "Nouvelle raison d'annulation"
  }
}

export const OrderCancelReasonCard = memo(({ orderCancelReason, formMethods, toggle }: OrderCancelReasonCardProps) => {
  const { subContainerHeight } = useDynamicSizes();

  const cardData = useWatch({
    control: formMethods.control,
  });

  const { name } = formatCardData(cardData);

  return (
    <Card>

      <HeaderGradient>
        <LinearGradient
          start={{ x: 0.5, y: 0 }}
          end={{ x: 0.5, y: 1 }}
          locations={[0, 1]}
          colors={['rgba(253, 255, 252, 0)', 'rgba(253, 255, 252, 1)']}
          style={styles.headerGradient}
        />
      </HeaderGradient>

      <Card.TopHeader>
        <Card.TopHeaderLabel>Fiche raison d'annulation</Card.TopHeaderLabel>
      </Card.TopHeader>

      <Card.Container height={subContainerHeight}>
        <Card.Background source={require('@app/assets/img/cardbackground.png')} />

        <Card.Content>
          <Card.Header>
            {/* En-tête */}
            <Row justify="space-between" align="center">
              <Card.HeaderTitles>
                <Card.Title numberOfLines={2}>{name}</Card.Title>
                {orderCancelReason?._id && <Card.Subtitle>Ref: {orderCancelReason._id}</Card.Subtitle>}
              </Card.HeaderTitles>

              <Card.ButtonAction onPress={toggle} permissionScope="order-cancel-reasons" />
            </Row>
          </Card.Header>
        </Card.Content>

        <MiniCard>
          <MiniCard.Container />
        </MiniCard>
      </Card.Container>
    </Card>
  );
});


const styles = StyleSheet.create({
  headerGradient: {
    flex: 1,
    height: theme.sizes.listHeaderHeight,
  },
});
